import { Quote } from "lucide-react";
import { Reveal, SectionEyebrow } from "@/components/Reveal";

const STEPS = [
  { n: "01", t: "Preview any beat", d: "Sixty free seconds on every track in the vault." },
  { n: "02", t: "Lease or own it", d: "Pick a lease tier or lock down exclusive rights." },
  { n: "03", t: "Pay your way", d: "Card, Apple Pay or Google Pay — fully secured checkout." },
  { n: "04", t: "Download instantly", d: "Files plus a written agreement, the second you check out." },
];

const CHIPS = ["Multi Album Credits", "Producer", "DJ", "Engineer"];

const Producer = () => (
  <section id="producer" className="relative py-24 md:py-32 lg:py-40 border-t border-white/5">
    <div className="max-w-[1440px] mx-auto px-6 md:px-12">
      <Reveal>
        <SectionEyebrow num="03" label="The Producer" />
      </Reveal>
      <Reveal delay={0.05}>
        <h2 className="font-display font-black uppercase tracking-tight leading-[0.95] mt-6 mb-14 text-[clamp(1.6rem,5vw,3.5rem)]">
          Sounds unique & <span className="text-vice">personal to the artist.</span>
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
        <Reveal className="md:col-span-8" delay={0.05}>
          <div className="relative h-[420px] md:h-[520px] overflow-hidden group flex items-start justify-center border border-white/10 bg-white/[0.03]">
            <img
              src="/images/logo-vice.jpg"
              alt="DJ Miami logo"
              className="h-[150px] md:h-[270px] w-auto object-contain pt-6 md:pt-10 transition-transform duration-700 group-hover:scale-[1.03]"
              data-testid="producer-portrait-img"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#050507] via-transparent to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-8">
              <div className="glass p-6 max-w-xl">
                <Quote size={20} className="text-[#D65BB4] mb-3" />
                <p className="text-sm md:text-base text-white/85 leading-relaxed">
                  I've worked with multi-platinum recording artists, producers and engineers. I'm
                  also a DJ — I cultivate sounds that are unique and personal to the artist.
                </p>
                <p className="text-xs uppercase tracking-[0.3em] text-[#4DBDBE] mt-4">— DJ Miami</p>
              </div>
            </div>
          </div>
        </Reveal>

        <Reveal className="md:col-span-4" delay={0.12}>
          <div className="h-full flex flex-col justify-between gap-8 border border-white/10 bg-white/[0.03] p-8">
            <p className="text-white/70 leading-relaxed">
              Miami made me. The MPC raised me. From 305 anthems to late-night R&B, every
              instrumental is built from scratch — no loops off a shelf, no recycled sounds. Just
              craft, feel, and that industry sound that your music has been missing.
            </p>
            <div className="flex flex-wrap gap-2.5">
              {CHIPS.map((c) => (
                <span
                  key={c}
                  className="text-xs uppercase tracking-widest border border-white/15 text-white/70 px-3 py-1.5 hover:border-[#D65BB4] hover:text-white transition-colors"
                >
                  {c}
                </span>
              ))}
            </div>
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.1}>
        <div className="mt-6 text-xs uppercase tracking-[0.35em] text-white/40 mb-6">How it works</div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.08}>
              <div className="border border-white/10 bg-white/[0.03] p-7 h-full transition-all duration-300 hover:-translate-y-1 hover:border-[#D65BB4]/50">
                <div className="font-display text-3xl font-black text-stroke">{s.n}</div>
                <div className="font-display font-bold uppercase text-sm mt-4">{s.t}</div>
                <p className="text-sm text-white/60 mt-2.5 leading-relaxed">{s.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);

export default Producer;
